import { useState, useEffect } from "react";
import { Pencil, X, Save, User, Building2 } from "lucide-react";
import "../../../assets/css/admin/adminEditProfile/AdminEditProfile.css";

const EditProfileModal = ({ isOpen, onClose, admin, onSave, isSaving }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    location: "",
    businessName: "",
    businessPhone: "",
    businessEmail: "",
    address: "",
  });

  useEffect(() => {
    if (isOpen) {
      setForm({
        name: admin.name || "",
        email: admin.email || "",
        phone: admin.phone || "",
        location: admin.location || "",
        businessName: admin.business_name || "",
        businessPhone: admin.business_phone || "",
        businessEmail: admin.business_email || "",
        address: admin.business_address || "",
      });
    }
  }, [isOpen, admin]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = () => {
    onSave(form);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className="epm-overlay" onClick={handleOverlayClick}>
      <div className="epm-modal">
        {/* Header */}
        <div className="epm-header">
          <div className="epm-title">
            <div className="epm-title-icon">
              <Pencil size={15} />
            </div>
            Edit Profile & Business Info
          </div>
          <button className="epm-close-btn" onClick={onClose}>
            <X size={15} />
          </button>
        </div>

        {/* ── Admin Profile Section ── */}
        <div className="epm-divider">
          <User size={12} />
          Admin Profile
        </div>

        <div className="epm-grid">
          <div className="epm-field">
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Enter full name"
            />
          </div>
          <div className="epm-field">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="admin@example.com"
            />
          </div>
          <div className="epm-field">
            <label>Phone Number</label>
            <input
              type="text"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="+92 300 0000000"
            />
          </div>
          <div className="epm-field">
            <label>Location</label>
            <input
              type="text"
              name="location"
              value={form.location}
              onChange={handleChange}
              placeholder="e.g. Lahore, Punjab"
            />
          </div>
        </div>

        {/* ── Business Info Section ── */}
        <div className="epm-divider">
          <Building2 size={12} />
          Business Information
        </div>

        <div className="epm-grid">
          <div className="epm-field">
            <label>Business Name</label>
            <input
              type="text"
              name="businessName"
              value={form.businessName}
              onChange={handleChange}
              placeholder="e.g. Furniture House PK"
            />
          </div>
          <div className="epm-field">
            <label>Business Phone</label>
            <input
              type="text"
              name="businessPhone"
              value={form.businessPhone}
              onChange={handleChange}
              placeholder="+92 42 0000000"
            />
          </div>
          <div className="epm-field">
            <label>Business Email</label>
            <input
              type="email"
              name="businessEmail"
              value={form.businessEmail}
              onChange={handleChange}
              placeholder="info@business.com"
            />
          </div>
          <div className="epm-field epm-full">
            <label>Full Address</label>
            <input
              type="text"
              name="address"
              value={form.address}
              onChange={handleChange}
              placeholder="Shop #, Street, City, Province"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="epm-footer">
          <button className="epm-cancel-btn" onClick={onClose} disabled={isSaving}>
            Cancel
          </button>
          <button
            className="epm-save-btn"
            onClick={handleSubmit}
            disabled={isSaving}
          >
            {isSaving ? (
              <>
                <span className="epm-spinner" />
                Saving...
              </>
            ) : (
              <>
                <Save size={14} />
                Save Changes
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditProfileModal;